import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

/**
 * OrgProtectedRoute Component
 * 
 * Kurumsal rotaları korur. Sadece kurumsal oturum açmış ve
 * belirtilen rollere sahip kullanıcılar erişebilir.
 * 
 * Props:
 *   - allowedRoles: ["admin", "teacher", "student"]
 *   - children: korunan bileşen
 */
export default function OrgProtectedRoute({ children, allowedRoles = [] }) {
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    const checkAuth = () => {
      try {
        const orgToken = sessionStorage.getItem("orgToken");
        const orgUserStr = sessionStorage.getItem("orgUser");

        if (!orgToken || !orgUserStr) {
          console.log("🚫 OrgProtectedRoute: No org session found");
          setIsAuthorized(false);
          return;
        }

        const orgUser = JSON.parse(orgUserStr);

        if (!orgUser.org_role || !orgUser.organization_id) {
          console.log("🚫 OrgProtectedRoute: Invalid org data");
          setIsAuthorized(false);
          return;
        }

        if (allowedRoles.length > 0 && !allowedRoles.includes(orgUser.org_role)) {
          console.log("🚫 OrgProtectedRoute: Role not allowed:", orgUser.org_role);
          setIsAuthorized(false);
          return;
        }

        console.log("✅ OrgProtectedRoute: Access granted", orgUser.email, orgUser.org_role);
        setIsAuthorized(true);
      } catch (error) {
        console.error("OrgProtectedRoute auth check error:", error);
        setIsAuthorized(false);
      }
    };

    checkAuth();
  }, [allowedRoles]);

  if (isAuthorized === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800">
        <div className="text-white text-xl">🔐 Yetki kontrol ediliyor...</div>
      </div>
    );
  }

  if (isAuthorized === false) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
